
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import DeleteSvg from './svg/DeleteSvg.vue';

export default defineComponent({
  name: 'DeleteIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      DeleteSvg: markRaw(DeleteSvg)
    };
  }
});
